import ReportHeader from './report_header';
import _ from 'underscore';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var RunSummary = function RunSummary(props) {
  var renderContent = function renderContent() {
    return /*#__PURE__*/_jsxs("div", {
      className: "overview mr-0 mb-0",
      children: [/*#__PURE__*/_jsxs("p", {
        className: "m-0 text-sm",
        children: [/*#__PURE__*/_jsx("strong", {
          children: props.program_version
        }), props.submitted_at && ", query submitted on ".concat(props.submitted_at)]
      }), /*#__PURE__*/_jsxs("p", {
        className: "m-0 text-sm",
        children: [/*#__PURE__*/_jsx("strong", {
          children: " Databases: "
        }), props.querydb.map(function (db) {
          return db.title;
        }).join(', '), ' ', "(", props.stats.nsequences, " sequences,\xA0", props.stats.ncharacters, " characters)"]
      }), /*#__PURE__*/_jsxs("p", {
        className: "m-0 text-sm",
        children: [/*#__PURE__*/_jsx("strong", {
          children: "Parameters: "
        }), ' ', _.map(props.params, function (val, key) {
          return key + ' ' + val;
        }).join(', ')]
      })]
    });
  };
  return /*#__PURE__*/_jsx(ReportHeader, {
    name: "Run Summary",
    renderContent: renderContent
  });
};
export default RunSummary;